import { useLogin } from '../hooks/use-login';
import { LoginForm } from '@/components/organisms/forms/login-form';
import type { LoginFormData } from '@/lib/validations';

export function LoginContainer() {
  const { login, isLoading, error, clearError } = useLogin();

  const handleSubmit = async (data: LoginFormData) => {
    await login({
      email: data.email,
      password: data.password,
      rememberMe: data.rememberMe,
    });
  };

  return (
    <LoginForm
      onSubmit={handleSubmit}
      isLoading={isLoading}
      error={error}
      onErrorClear={clearError}
    />
  );
}
